import { PageHeader } from "@ant-design/pro-components";
import { CopyAllOutlined, MarkChatReadOutlined, Message } from "@mui/icons-material";
import { Alert, Button, Card, Form, Input, message, Select, Textarea } from "antd";
import { memo, useEffect, useState } from "react";
import api from "../../../api/api";
import styles from "./SentSmsReport.module.css";
import DataTable from "../../../Components/DataTable/DataTable";
import { toJalaali } from "jalaali-js";

const SentSmsReport = () => {
  const [sentList, setSentList] = useState([]);
  const [totalSents, setTotalSents] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(1000);

  const columns = [
    {
      title: "شناسه",
      dataIndex: "id",
      searchable: true,
    },
    {
      title: "موبایل",
      dataIndex: "mobile",
      searchable: true,
    },
    {
      title: "قالب",
      dataIndex: "template",
      searchable: true,
    },
    {
      title: "متن",
      dataIndex: "content",
      render: (ـ, record) => {
        return <span className={styles.smsContent}>{record.content}</span>;
      },
    },
    {
      title: "خط",
      dataIndex: "line_number",
      searchable: true,
    },
    {
      title: "اپراتور",
      dataIndex: "provider",
      searchable: true,
    },
    {
      title: "زمان ایجاد",
      dataIndex: "created_at",
      render: (text, record) => {
        if (text && text != "-") {
          const date = new Date(text);
          const jalali = toJalaali(date.getFullYear(), date.getMonth() + 1, date.getDate());
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd} {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "زمان ارسال",
      dataIndex: "sent_at",
      render: (text, record) => {
        if (text && text != "-") {
          const date = new Date(text);
          const jalali = toJalaali(date.getFullYear(), date.getMonth() + 1, date.getDate());
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd} {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "ارسال کننده",
      dataIndex: "send_by_fullname",
      searchable: true,
    },
  ];

  useEffect(() => {
    loadSentList();
  }, []);

  const loadSentList = () => {
    api.get("/smslogs/sent?pageNumber=" + pageNumber + "&pageSize=" + pageSize).then((res) => {
      const data = res.data;
      setSentList(data.sentList);
      setTotalSents(data.totalSents);
    });
  };

  return (
    <DataTable
      id="SentList"
      dataSource={sentList}
      setDataSource={setSentList}
      columns={columns}
      // permissionsPrefix="flags"
      reload={loadSentList}
      recordsCount={totalSents}
      recordCreatorDisabled
      header={{
        title: "گزارش پیامک ارسالی",
        avatar: { icon: <MarkChatReadOutlined />, size: "large" },
      }}
    />
  );
};

export default memo(SentSmsReport);
